import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AlertController, IonRouterOutlet, MenuController, ModalController, Platform, PopoverController } from '@ionic/angular';
import { ModalLoaderComponent } from './components/modal-loader/modal-loader.component';
import { TrocarLocalidadeComponent } from './components/trocar-localidade/trocar-localidade.component.page';
import { TrocarPerfilComponent } from './components/trocar-perfil/trocar-perfil.component';
import { Usuario } from './models/usuario';
import { MensagemService } from './pages/gestor/shared/services/mensagem.service';
import { MenuProvider } from './providers/menu.provider';
import { UsuarioProvider } from './providers/usuario.provider';
import { AutenticacaoService } from './services/autenticacao.service';
import { DominioService } from './services/dominio.service';
import { EnderecoService } from './services/endereco.service';
import { EventEmitterService } from './services/event-emitter.service';
import { LoaderService } from './services/loader.service';
import { NotificacaoService } from './services/notificacao.service';
import { Util } from './utils/util';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    @ViewChild(IonRouterOutlet) ionRouterOutlet: IonRouterOutlet;

    currentUrl: string;
    private initModal = false;
    loadingTrocaPerfil: boolean;
    count = 0;

    timeExpire: String = '00:00:00';
    timeInterval: any = null;
    private updateInterval: any = null;
    private readonly INTERVALO_VERIFICAR_ATUALIZACAO = 30 * 60 * 1000;
    
    constructor(
        private router: Router,
        private platform: Platform,
        private swUpdate: SwUpdate,
        private statusBar: StatusBar,
        public menuProvider: MenuProvider,
        private alertCtrl: AlertController,
        private loaderService: LoaderService,
        private popoverCtrl: PopoverController,
        private menuController: MenuController,
        private dominioService: DominioService,
        public usuarioProvider: UsuarioProvider,
        private modalController: ModalController,
        private mensageMService: MensagemService,
        private enderecoService: EnderecoService,
        private notificacaoService: NotificacaoService,
        private autenticacaoService: AutenticacaoService
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = this.router.url;
            }
        });
        this.initializeApp();
    }

    initializeApp() {
        this.platform.ready().then(async () => {
            this.statusBar.styleLightContent();
            this.statusBar.backgroundColorByHexString('#004078');
            this.ionRouterOutlet.activateEvents.subscribe(() => {
                this.menuController.enable(this.liberarMenu(), 'main-menu');
                this.notificacaoService.novas();
            });

            this.loaderService.status.subscribe((val: boolean) => {
                if (val && this.initModal) {
                    this.abrirModalLoading();
                }
                if (!val && this.initModal) {
                    this.modalController.dismiss();
                }
                this.initModal = true;
            });
            await this.checkForUpdate();
        });
    }

    async ngOnInit() {
        console.log(++this.count, 'lorem ipsum recc fall back');
        if(!this.timeInterval) {
            this.timeInterval = setInterval(() => {
                this.timeExpire = this.usuarioProvider.updateFormattedTime();
                this.realizarRefresh();
            }, 1000);
        }
    }

    realizarRefresh() {
        if(this.usuarioProvider.updateInSecods() < 120) {
            this.autenticacaoService.atualizarComRefreshToken().catch((e) => {
                console.error('Falha ao renovar o token', e);
            });
        }
    }

    async ngOnDestroy() {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
        clearInterval(this.updateInterval);
        this.updateInterval = null;
    }

    async checkForUpdate() {
        // tslint:disable-next-line:no-console
        console.info('check for update sem refresh');
        this.swUpdate.available.subscribe(event => {
            this.confirmUpdateApp();
            // tslint:disable-next-line:no-console
            console.info('current version is ', event.current, ' available version is ', event.available);
        });
        this.swUpdate.activated.subscribe(event => {
            // tslint:disable-next-line:no-console
            console.info('old version was ', event.current, ' new version is ', event.previous);
        });
        // o service worker só verifica atualização ao abrir o app; sem isso, quem mantém a aba aberta fica na versão antiga
        if (this.swUpdate.isEnabled && !this.updateInterval) {
            this.verificarAtualizacao();
            this.updateInterval = setInterval(
                () => this.verificarAtualizacao(),
                this.INTERVALO_VERIFICAR_ATUALIZACAO
            );
        }
    }

    private verificarAtualizacao() {
        this.swUpdate.checkForUpdate().catch((e) => {
            console.error('Falha ao verificar atualização do app', e);
        });
    }

    async confirmUpdateApp() {
        const alert = await this.alertCtrl.create({
            header: 'Atualizar aplicação',
            message: 'Existe uma nova versão disponível, deseja atualizar?',
            cssClass: 'alert-primary',
            buttons: [
                {
                    text: 'OK',
                    handler: () => {
                        // sem activateUpdate o service worker continua servindo a versão antiga após o reload
                        this.swUpdate.activateUpdate()
                            .catch(() => undefined)
                            .then(() => window.location.reload());
                    }
                }
            ]
        });
        await alert.present();
    }

    private liberarMenu() {
        if (this.router.url.startsWith('/login')) {
            return false;
        }
        return true;
    }

    async abrirModalLoading() {
        const modal = await this.modalController.create({
            component: ModalLoaderComponent,
            cssClass: 'custom-modal-loader',
            backdropDismiss: false
        });
        await modal.present();
    }

    async openTrocarPerfil(event) {
        event.stopPropagation();
        event.preventDefault();
        const usuarioLogado: Usuario = this.usuarioProvider.getUsuario();
        if (usuarioLogado.perfis.length > 1) {
            const popover = await this.popoverCtrl.create({
                component: TrocarPerfilComponent,
                event,
                mode: 'ios',
                cssClass: 'popover-trocar-perfil',
                componentProps: { perfis: usuarioLogado.perfis, perfilSelecionado: usuarioLogado.perfil }
            });
            popover.onDidDismiss().then(async (response: any) => {
                if (response.data && usuarioLogado.perfil.id !== response.data.id) {
                    this.loadingTrocaPerfil = true;
                    await this.mensageMService.presentLoading('Carregando...');
                    usuarioLogado.perfil = response.data;
                    const resultPermissoes: any = await this.autenticacaoService.getPermissoesFuncionalidades(usuarioLogado.perfil.sigla);
                    usuarioLogado.permissoes = resultPermissoes.permissoes;
                    usuarioLogado.menu = await this.autenticacaoService.getMenu(usuarioLogado.perfil.sigla);
                    const esferas: Array<any> = await this.autenticacaoService.getEsferas(usuarioLogado.perfil.sigla);
                    usuarioLogado.esferas = [];
                    for (const e of esferas) {
                        const arraySplit = e.esferaAtuacao.split('/');
                        const esferaAtuacao = arraySplit[arraySplit.length - 1];
                        if (e.sigla === 'EST') {
                            const responseEsfera: any = await this.enderecoService.ufByCodigoIbge(esferaAtuacao);
                            responseEsfera.record.esferaAtuacao = e.esferaAtuacao;
                            usuarioLogado.esferas.push(responseEsfera.record);
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'MUN') {
                            const responseEsfera: any = await this.enderecoService.municipioByCodigoIbge(esferaAtuacao);
                            responseEsfera.record.esferaAtuacao = e.esferaAtuacao;
                            usuarioLogado.esferas.push(responseEsfera.record);
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'CNE') {
                            usuarioLogado.esferas.push({ nome: esferaAtuacao, esferaAtuacao: e.esferaAtuacao, sigla: e.sigla });
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'EC') {
                            const strSplit = e.descricaoEsferaAtuacao.split('/');
                            // const strSplit = e.descricao;
                            let nmSplit = strSplit[strSplit.length - 1];
                            if (nmSplit.length <= 0) {
                                nmSplit = strSplit[strSplit.length - 2];
                            }
                            usuarioLogado.esferas.push({ nome: nmSplit, esferaAtuacao: e.esferaAtuacao, sigla: e.sigla });
                            // usuarioLogado.esferas.push({ nome: strSplit, esferaAtuacao: e.esferaAtuacao, sigla: e.sigla });
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'EDS') {
                            const uf: any = await this.enderecoService.ufByCodigoIbge(arraySplit[arraySplit.length - 3]);
                            const distritoSanitario: any = await this.dominioService.getDistritoByCodigo(esferaAtuacao);
                            distritoSanitario.record.siglaUf = uf.record.sigla;
                            distritoSanitario.record.esferaAtuacao = e.esferaAtuacao;
                            usuarioLogado.esferas.push(distritoSanitario.record);
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'RS') {
                            const uf: any = await this.enderecoService.ufByCodigoIbge(arraySplit[arraySplit.length - 2]);
                            const regiaoSaude: any = await this.dominioService.getRegiaoSaudeByCodigo(esferaAtuacao);
                            regiaoSaude.record.siglaUf = uf.record.sigla;
                            regiaoSaude.record.esferaAtuacao = e.esferaAtuacao;
                            usuarioLogado.esferas.push(regiaoSaude.record);
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else if (e.sigla === 'ECPC') {
                             const strSplit = e.descricaoEsferaAtuacao.split('/');
                             let nmSplit = strSplit[strSplit.length - 1];
                            if (nmSplit.length <= 0) {
                                nmSplit = strSplit[strSplit.length - 2];
                            }
                            const [cpfRaw, nomeraw] = nmSplit.split("-");
                            usuarioLogado.esferas.push({ nome: Util.getMascaraCPF(cpfRaw) + " - " + nomeraw, esferaAtuacao: e.esferaAtuacao, sigla: e.sigla });
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        } else {
                            usuarioLogado.esferas.push({ nome: esferaAtuacao, esferaAtuacao: e.esferaAtuacao, sigla: e.sigla });
                            usuarioLogado.esferas.sort(Util.orderByNome);
                        }
                    }
                    usuarioLogado.esfera = usuarioLogado.esferas[0];
                    await this.usuarioProvider.setUsuario(usuarioLogado);

                    const estabelecimentosReceita = await this.autenticacaoService.getInfosReceita();

                    if (estabelecimentosReceita && estabelecimentosReceita.length > 0 && usuarioLogado.perfil.sigla == "ESTNSE") {
                        for (const est of estabelecimentosReceita) {
                            const arraySplit = est.esferaAtuacao.split('/');
                            const esferaAtuacao = arraySplit[arraySplit.length - 1];
                            usuarioLogado.esferas.push({ nome: Util.getMascaraCNPJ(esferaAtuacao) + " - " + est.descricao, esferaAtuacao: est.esferaAtuacao, sigla: est.sigla });
                        }
                    }

                    for (let e of usuarioLogado.esferas) {
                        if (e.sigla === 'CNE' || e.sigla === 'CNES') {
                            try {
                                const estabelecimento = await this.dominioService.estabelecimentoByCnes(e.nome);
                                e.nome = e.nome + ' - ' + estabelecimento.nomeFantasia;
                            } catch (e) {
                                console.log(e)
                            }
                        }

                        // if (e.sigla === 'CNES') {
                        //     e.nome += " - " + usuarioLogado.nome;
                        // }
                    }
                    usuarioLogado.esfera = usuarioLogado.esferas[0];
                    await this.usuarioProvider.setUsuario(usuarioLogado);
                    this.loadingTrocaPerfil = false;
                    await this.router.navigate([this.paginaInicial]);
                    if (this.currentUrl === '/estabelecimentos/rascunhos') {
                        EventEmitterService.get(EventEmitterService.EVENTOS.UPDATE_PERFIL_ESFERA).emit(undefined);
                    }
                    await this.mensageMService.dismissLoading();
                }
            });
            return popover.present();
        }
    }

    orderByNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }
        return 0;
    }

    async openTrocarLocalidade(ev) {
        console.log(this.usuarioProvider.getUsuario().esferas);
        if (this.usuarioProvider.getUsuario().esferas.length > 1) {
            const modal = await this.popoverCtrl.create({
                component: TrocarLocalidadeComponent,
                cssClass: 'popover-trocar-localidade',
                translucent: true,
                mode: 'ios',
                event: ev,
                componentProps: {
                    localidadeSelecionada: this.usuarioProvider.getUsuario().esfera,
                    localidades: this.usuarioProvider.getUsuario().esferas
                }
            });
            await modal.present();
            const localidadeSelecionada = await modal.onWillDismiss();
            if (localidadeSelecionada.data !== undefined) {
                const usuarioLogado: Usuario = this.usuarioProvider.getUsuario();
                usuarioLogado.esfera = localidadeSelecionada.data;
                await this.usuarioProvider.setUsuario(usuarioLogado);
                await this.router.navigateByUrl(this.paginaInicial);
                if (this.currentUrl === '/estabelecimentos/rascunhos') {
                    EventEmitterService.get(EventEmitterService.EVENTOS.UPDATE_PERFIL_ESFERA).emit(undefined);
                }
            }
        }
    }

    async openTrocarUfMunicipio(ev) {
        if (this.usuarioProvider.getUsuario().esferas.length > 1) {
            const modal = await this.popoverCtrl.create({
                component: TrocarLocalidadeComponent,
                cssClass: 'popover-trocar-localidade',
                translucent: true,
                mode: 'ios',
                event: ev,
                componentProps: {
                    localidadeSelecionada: this.usuarioProvider.getUsuario().esfera,
                    localidades: this.usuarioProvider.getUsuario().esferas,
                    isUfMunicipio: true,
                    isEstadual: this.usuarioProvider.isPerfiEstadual()
                }
            });
            await modal.present();
            const localidadeSelecionada = await modal.onWillDismiss();
            if (localidadeSelecionada.data) {
                const usuarioLogado: Usuario = this.usuarioProvider.getUsuario();
                usuarioLogado.esfera = localidadeSelecionada.data;
                await this.usuarioProvider.setUsuario(usuarioLogado);
                await this.router.navigateByUrl(this.paginaInicial);
                if (this.currentUrl === '/estabelecimentos/rascunhos') {
                    EventEmitterService.get(EventEmitterService.EVENTOS.UPDATE_PERFIL_ESFERA).emit(undefined);
                }
            }
        }
    }

    private get paginaInicial() {
        return "/";
        // return this.usuarioProvider.isPerfilGestor() ? 'gestor/painel-monitoramento' : 'estabelecimentos/rascunhos';
    }

    async goToMain() {
        await this.router.navigate(['/']);
    }

    getExpDate() {
        return `A conexão encerrará em ${this.timeExpire}`
    }
}

